<div class="standalone-flavor-option">
  <div class="standalone-flavor-option--header">
    <div *ngIf="!standAloneOptionLogoUrl" class="standalone-flavor-option--title" [translate]="orderOption.titleKey"></div>
    <img *ngIf="standAloneOptionLogoUrl" class="standalone-flavor-option--logo" src="{{standAloneOptionLogoUrl}}"/>
  </div>
  <div class="standalone-flavor-option--body">
    <div class="standalone-flavor-option--description-text ">
      <ul class="list-style--v2" [innerHTML]="orderOption.descriptionKey | translate"></ul>
    </div>

    <div class="standalone-flavor-option--below-part bottom">
      <div>
        <app-order-button class="smallHeight" *ngIf="pack"
                          [x]="x"
                          [y]="y"
                          [pack]="pack"
                          [ownerComponent]="ownerComponent"
                          (emitOnEnterPressed)="onEmitOrderProduct($event)"
                          (emitOnBack)="onBack()"
                          [subPack]="pack">
        </app-order-button>
      </div>
      <div class="standalone-flavor-option--price">
        <div class="price-box">
          <div class="price">
            <div class="price-left">€</div>
            <div class="price-left">{{priceBeforeComma}}</div>
            <div class="price-right">
              <span class="comma">{{getPriceTextDecimalPart}}</span>
              <div class="after">/<span [translate]="'eos-tv-shop-ii.lbl.price-month'"></span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<!--  TODO: Handle condition to show the badge-->
  <app-badge *ngIf="false" [badgeCopy]="badgeCopyKey | translate" [rendition]="'secondary'" [position]="'tr'"></app-badge>
</div>
